import { actionTypes } from '../actions/header'

const initial = {
	panelFavs: false,
	panelProfile: '',
	modalProfile: false,
  details: false,
  telephone: '41141000'
}

export default (state = initial, action) => {
  switch (action.type) {
  	case actionTypes.SET_PANEL_FAVS:
      return Object.assign({}, state, {
        panelFavs: !state.panelFavs,
        panelProfile: false
    })

    case actionTypes.SET_PANEL_PROFILE:
      return Object.assign({}, state, {
        panelProfile: !state.panelProfile,
        panelFavs: false
    })

    case actionTypes.SET_MODAL_HEADER:
      return Object.assign({}, state, {
        modalProfile: !state.modalProfile,
        panelProfile: false
    })

    case actionTypes.SHOW_DETAILS:
      return Object.assign({}, state, {
        details: !state.details,
    })

    case actionTypes.SET_PHONE:
      return Object.assign({}, state, {
        telephone: action.value,
    })

  	default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/header.js